import {
  SET_STUDENT,
  SET_STUDENT_POSITION,
  SET_STUDENT_NEXT_POSITION,
  SET_TELEMETRY_DATA,
  RESET_STUDENT,
  RESET_PROGRESS,
  SET_MODULE_SOUNDS,
  SET_STUDENT_CURRENT_CC,
  SET_SHOW_CLOSED_CAPTIONS
} from '../types/student';

export const initialState = {
  id: '',
  firstName: '',
  lastName: '',
  username: '',
  gradeLevel: '',
  classroom: {},
  currentPosition: [],
  nextPosition: null,
  characterOrder: '',
  freePlay: false,
  moduleSound: {},
  settings: {
    accessibility: { audioSettings: { muteSounds: false } }
  },
  showCC: false
};

export default (state = initialState, action) => {
  switch (action.type) {
    case SET_STUDENT:
      return {
        ...state,
        ...action.payload
      };
    case SET_TELEMETRY_DATA:
      return { ...state, ...action.payload };
    case SET_MODULE_SOUNDS:
      return { ...state, ...action.payload };
    case SET_STUDENT_POSITION:
      return {
        ...state,
        currentPosition: action.payload,
        nextPosition: null
      };
    case SET_STUDENT_NEXT_POSITION:
      return {
        ...state,
        nextPosition: action.payload
      };
    case SET_STUDENT_CURRENT_CC:
      return {
        ...state,
        currentCaption: action.payload
      };
    case SET_SHOW_CLOSED_CAPTIONS:
      return {
        ...state,
        showCC: action.payload
      };
    case RESET_PROGRESS:
      return {
        ...state,
        currentPosition: [],
        nextPosition: null
      };
    case RESET_STUDENT:
      return { ...initialState };
    default:
      return state;
  }
};
